export default class Helpers {
    // Parses a JSON string and returns the corresponding object or null if parsing fails
    static parseJsonString(jsonString) {
        try {
            return JSON.parse(jsonString);
        }
        catch (error) {
            console.error('Error parsing JSON string:', error);
            return null;
        }
    }
}
